/**
 * A function that calculates the flight time of the aircraft.
 * @param {Number} distance The route distance in km.
 * @param {Number} speed The aircraft speed distance in km per hour.
 * @return {Number} The flight time in seconds.
 */
const calcFlightTime = (distance, speed) => ((distance / speed) * 3600) / 1.5; // seconds

export { calcFlightTime };
export default calcFlightTime;
